import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import SkipLink from './SkipLink';
import CommandPalette from './CommandPalette';
import './layout.css';

interface Props {
  children: React.ReactNode;
}

const SiteShell: React.FC<Props> = ({ children }) => {
  const [cmdkOpen, setCmdkOpen] = useState(false);
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault();
        setCmdkOpen(v => !v);
      } else if (e.key === 'Escape') {
        setCmdkOpen(false);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <SkipLink />
      {!isAdminRoute && <Navbar onOpenCmdk={() => setCmdkOpen(true)} />}
      <main id="main-content" style={{ flex: 1 }}>
        {children}
      </main>
      {!isAdminRoute && <Footer />}
      <CommandPalette open={cmdkOpen} onClose={() => setCmdkOpen(false)} />
    </div>
  );
};

export default SiteShell;
